import { Component, OnInit } from '@angular/core';
import { TableColumn } from '../../../dto/util/table-column';
import { FormulariosEnviadosService } from '../../../services/formularios-enviados.service';
import { ListadoConsolidadoDto } from '../../../dto/integrador/listado-consolidado.dto';
import { ListadoFormulariosPaginadoDto } from '../../../dto/integrador/listado-formularios-paginado.dto';
import moment from 'moment';
import { DescargaConsolidadosDto } from '../../../dto/integrador/descarga-consolidados.dto';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-formularios-enviados',
  templateUrl: './formularios-enviados.component.html',
  styleUrl: './formularios-enviados.component.scss',
})
export class FormulariosEnviadosComponent implements OnInit {
  columns: TableColumn[] = [];
  data: ListadoConsolidadoDto[] = [];
  selectedItems: any = [];
  selectedYear!: number;
  selectedMonth!: number;
  yearsFilter: number[] = [];
  monthFilter: { valor: number; nombre: string }[] = [];
  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth();
  filtros: any = {};
  userType: any = null;
  params: any = {};
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;

  monthLabels = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  // Multilenguaje
  formEnviadosText: any = {};

  constructor(
    private readonly service: FormulariosEnviadosService,
    private readonly translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.userType = JSON.parse(sessionStorage.getItem('user_type')!);
    this.getData(this.getFiltros());
    this.translate.stream('formularios_enviados').forEach(text => {
      for (const key of Object.keys(text)) {
        this.formEnviadosText[key] = text[key];
      }
      this.initColumns();
    });
  }

  getData(filtros: any) {
    this.service
      .listadoConsolidado(filtros)
      .subscribe((response: ListadoFormulariosPaginadoDto) => {
        this.data = response.data;
        this.data.forEach(
          register => (register['descargar'] = this.formEnviadosText['descargar'])
        );
        this.totalPaginas = response.totalPages;
        if (this.monthFilter.length == 0 && this.yearsFilter.length == 0) {
          this.getDataFilter();
        }
      });
  }

  getDataFilter() {
    const yearsSet = new Set<number>();
    const monthSet = new Set<{ valor: number; nombre: string }>();

    this.data.forEach((item, index) => {
      item.id = index;
      item.descargar = 'Descargar';
      let fechaMoment = moment(item.fecha, 'DD/MM/YYYY', true);
      let year = fechaMoment.year();
      let month = fechaMoment.month() + 1;
      yearsSet.add(year);
      monthSet.add({ valor: month, nombre: this.monthLabels[month - 1] });
    });

    this.yearsFilter = Array.from(yearsSet).sort((a, b) => a - b);
    this.monthFilter = Array.from(monthSet).sort((a, b) => a.valor - b.valor);
  }

  initColumns() {
    this.columns = [
      {
        field: 'seleccion',
        title: this.formEnviadosText['seleccion'],
        type: 'select',
        filterable: false,
        sortable: false,
      },
      {
        id: 'fecha',
        field: 'fecha',
        title: this.formEnviadosText['fecha'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'nombreArchivo',
        field: 'nombreArchivo',
        title: this.formEnviadosText['archivo'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'cantidadRegistros',
        field: 'cantidadRegistros',
        title: this.formEnviadosText['cantidad_formularios'],
        type: 'number',
        filterable: false,
        sortable: false,
      },
      {
        id: 'descargar',
        field: 'descargar',
        title: this.formEnviadosText['descargar'],
        type: 'html',
        filterable: false,
        sortable: false,
        accion: (item: ListadoConsolidadoDto) => {
          this.descargaUnica(item);
        },
      },
    ];
  }

  descargar(consolidados: DescargaConsolidadosDto[]) {
    this.service
      .descargarConsolidados(consolidados)
      .subscribe((response: any) => {
        const buffer = new Uint8Array(response.data).buffer;
        const blob = new Blob([buffer], { type: 'application/zip' });
        this.blobToSaveAs('Consolidados.zip', blob);
      });
  }

  blobToSaveAs(fileName: string, blob: Blob) {
    try {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      if (link.download !== undefined) {
        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (e) {
      console.error('BlobToSaveAs error', e);
    }
  }

  convertBase64ToZip(base64: string) {
    const binaryString = atob(base64); // Decodifica la cadena Base64
    const binaryLength = binaryString.length;
    const bytes = new Uint8Array(binaryLength);

    // Convertir cada carácter en un byte
    for (let i = 0; i < binaryLength; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Crear un Blob para el archivo ZIP
    const blob = new Blob([bytes], { type: 'application/zip' }); // Especificar el tipo MIME adecuado

    // Crear un enlace para descargar el archivo
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'consolidados.zip'; // Nombre del archivo ZIP
    document.body.appendChild(a);
    a.click();

    // Limpiar recursos
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  handleSelectedItems(selectedItems: any[]) {
    this.selectedItems = selectedItems;
  }

  getFiltros() {
    let anioFiltro = this.selectedYear > 0 ? this.selectedYear : null;
    let mesFiltro = this.selectedMonth > 0 ? this.selectedMonth : null;

    return {
      anio: anioFiltro ? anioFiltro : '',
      mes: mesFiltro ? mesFiltro : '',
      idEntidad: this.userType.Id_Entidad,
      page: this.paginaActual,
      limit: this.tamanoPagina,
    };
  }

  filtrar() {
    this.getData(this.getFiltros());
  }

  descargaUnica(item: ListadoConsolidadoDto) {
    this.descargar([
      {
        fecha: moment(item.fecha, 'DD/MM/YYYY').format('YYYY/MM/DD'),
        idEntidad: item.idEntidad,
      },
    ]);
  }

  descargaMasiva() {
    let request: DescargaConsolidadosDto[] = [];
    this.selectedItems.map((item: DescargaConsolidadosDto) => {
      request.push({
        fecha: moment(item.fecha, 'DD/MM/YYYY').format('YYYY/MM/DD'),
        idEntidad: item.idEntidad,
      });
    });

    this.descargar(request);
  }
}
